import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Image,
  Button,
  Link,
  Progress,
  IconButton,
} from '@chakra-ui/react';
import { MdPlayArrow, MdPause, MdSkipNext, MdSkipPrevious } from 'react-icons/md'; // Chakra UI supports react-icons

const PodcastEpisode = () => {
  const [isPlaying, setIsPlaying] = React.useState(false);

  return (
    <Container maxW="4xl" py={12}>
      {/* Episode Header */}
      <VStack spacing={8} align="stretch">
        <Box
          bg="blue.50"
          p={8}
          borderRadius="xl"
          boxShadow="lg"
          textAlign="center"
         >
          <VStack spacing={6}>
            {/* <Image
              src="/api/placeholder/300/300"
              alt="AI in Hiring"
              borderRadius="lg"
              width={300}
              height={300}
            /> */}

            <VStack spacing={3}>
              <Heading size="lg" color="blue.700">
                AI Transforming Hiring: A Conversation with Manjari Gupta
              </Heading>
              <Text color="gray.600" fontSize="lg">
                Founder of Aptofy 
              </Text>
            </VStack>

            {/* Audio Player */}
            <Box w="full" maxW="md">
              <Progress value={30} size="sm" colorScheme="blue" mb={4} />
              <HStack justify="center" spacing={4}>
                <IconButton
                  icon={<MdSkipPrevious />}
                  aria-label="Skip Back"
                  size="lg"
                  variant="ghost"
                />
                <IconButton
                  icon={isPlaying ? <MdPause /> : <MdPlayArrow />}
                  aria-label={isPlaying ? 'Pause' : 'Play'}
                  size="lg"
                  colorScheme="blue"
                  rounded="full"
                  onClick={() => setIsPlaying(!isPlaying)}
                />
                <IconButton
                  icon={<MdSkipNext />}
                  aria-label="Skip Forward"
                  size="lg"
                  variant="ghost"
                />
              </HStack>
                {/* Call to Action */}
            <Link
              href="https://lnkd.in/gx8AweBK"
              isExternal
              _hover={{ textDecoration: 'none' }}
            >
              <Button
                colorScheme="blue"
                size="lg"
                width="full"
                mt={4}
              >
                Click to Listen Full Episode
              </Button>
            </Link>
            </Box>
          </VStack>
        </Box>

        {/* Episode Description */}
        <Box  p={8} borderRadius="xl" boxShadow="md">
          <VStack spacing={6} align="stretch">
            <Heading size="md" color="blue.700">
              About This Episode
            </Heading>
            <Text fontSize="lg" lineHeight="tall">
              In this engaging conversation, Manjari Gupta shares groundbreaking
              insights into how AI is transforming hiring and fostering growth.
              As the founder of Unlimiteye and Aptofy Solutions, she discusses
              their mission to empower users with real-world, cheat-proof,
              skill-based, and bias-free assessments.
            </Text>
            <Text fontSize="lg" lineHeight="tall">
              Learn how Aptofy Solutions is revolutionizing talent acquisition,
              making it more efficient and fair through innovative AI
              technologies. Manjari shares her visionary approach to enhancing
              recruitment processes and driving career development in this
              must-listen episode.
            </Text>

          

            {/* Key Topics */}
            <Box mt={6}>
              <Heading size="sm" mb={3} color="gray.600">
                Key Topics Covered:
              </Heading>
              <VStack align="stretch" spacing={2} pl={4}>
                <Text>• AI-driven recruitment processes</Text>
                <Text>• Bias-free assessment methods</Text>
                <Text>• Future of talent acquisition</Text>
                <Text>• Career development in the AI era</Text>
                <Text>• Innovation in HR technology</Text>
              </VStack>
            </Box>
          </VStack>
        </Box>
      </VStack>
    </Container>
  );
};

export default PodcastEpisode;
